import { render, staticRenderFns } from "./phoneAuthentication.vue?vue&type=template&id=3e348c10&scoped=true&"
import script from "./phoneAuthentication.vue?vue&type=script&lang=js&"
export * from "./phoneAuthentication.vue?vue&type=script&lang=js&"
import style0 from "./phoneAuthentication.vue?vue&type=style&index=0&id=3e348c10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e348c10",
  null
  
)

export default component.exports